module.exports = __webpack_public_path__ + "media/images/Software-fb6b71de04ebb709426d28bb58e05b80.svg";